import { getSizeSettings } from "../../../utils/get-size-settings";
import { ViewObjectContainerParser } from "../view-object-container-parser";
import { SettingsParser } from "../settings-parser";
import { GridSettings } from "../../settings/view-objects/grid-settings";

export class GridSettingsParser extends ViewObjectContainerParser {
  constructor(viewObjectParsers) {
    super(viewObjectParsers);
    this.parsedFieldNames.push("rowsSpace");
    this.parsedFieldNames.push("rows");
  }

  static createSettings(settings, defaultSettings, viewObjectParsers) {
    let parsedSettings = ViewObjectContainerParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    let defaultViewObjects = settings._defaultViewObjects;
    parsedSettings.rowsSpace = getSizeSettings(settings.rowsSpace ?? defaultSettings?.rowsSpace, 0, 0);
    if (settings.rows !== undefined) {
      parsedSettings.rows = [];
      for (let rowIndex = 0; rowIndex < settings.rows.length; rowIndex++) {
        let rowSettings = settings.rows[rowIndex];
        let rowInfo = {
          height: getSizeSettings(rowSettings.height ?? defaultSettings?.rowSettings?.height, 0, 1),
          columnsSpace: getSizeSettings(rowSettings.columnsSpace ?? defaultSettings?.rowSettings?.columnsSpace, 0, 0),
          columns: []
        };
        for (let columnIndex = 0; columnIndex < rowSettings.columns.length; columnIndex++) {
          let columnSettings = rowSettings.columns[columnIndex];
          rowInfo.columns.push({
            width: getSizeSettings(columnSettings.width ?? defaultSettings?.columnSettings?.width, 0, 1),
            item: ViewObjectContainerParser.parseItem(columnSettings.item, viewObjectParsers, defaultViewObjects)
          });
        }
        parsedSettings.rows.push(rowInfo);
      }
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = GridSettingsParser.createSettings(settings, defaultSettings, this.viewObjectParsers);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new GridSettings(parsedSettings);
  }
}
